import { useUserExtraData } from '~common/providers/useUserExtraData';

export function useSaleContributionData(poolId: string) {
  const { contributions } = useUserExtraData();
  const contribution = contributions.find((c) => c.poolId === poolId);

  return { contribution };
}
